export const markdownStyles = {
  table: {
    props: {
      style: {
        borderCollapse: 'collapse',
        border: '1px dashed #bbb',
        borderSpacing: '2px',
        width: '100%',
        tableLayout: 'fixed',
        marginBottom: '15px',
      },
    },
  },
  td: { props: { style: { border: '1px dashed #bbb', padding: '6px' } } },
  th: { props: { style: { border: '1px dashed #bbb', padding: '6px', textAlign: 'center' } } },
};
